/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
*/

import { Organization, User } from '../../data/interfaces';
import {
    USER_LOGIN_REQUEST, USER_LOGIN_SUCCESS, USER_LOGIN_FAILURE, REQUIRE_LOGIN,
    USER_INFO_REQUEST, USER_INFO_SUCCESS, USER_INFO_FAILURE,
    USER_ORG_INFO_REQUEST, USER_ORG_INFO_SUCCESS, USER_ORG_INFO_FAILURE,
    CHANGE_ORG_REQUEST, CHANGE_ORG_SUCCESS, CHANGE_ORG_FAILURE,
    OBTAIN_APIM_TOKEN_SUCCESS, OBTAIN_APIM_TOKEN_REQUEST, OBTAIN_APIM_TOKEN_FAILURE,
    ADD_ENTERPRISE_USER_REQUEST, ADD_ENTERPRISE_USER_SUCCESS, ADD_ENTERPRISE_USER_FAILURE
} from '../types/user';
import { DecodedIDTokenPayload } from '@asgardeo/auth-react';

export const userLoginRequest = () => {
    return {
        type: USER_LOGIN_REQUEST
    }
}

export const userLoginSuccess = (user: User) => {
    return {
        type: USER_LOGIN_SUCCESS,
        payload: user,
    }
}

export const userLoginFailure = (error: string) => {
    return {
        type: USER_LOGIN_FAILURE,
        payload: error
    }
}

export const requireLogin = () => {
    return {
        type: REQUIRE_LOGIN
    }
}

export const fetchUserInfoRequest = () => {
    return {
        type: USER_INFO_REQUEST
    }
}

export const fetchUserInfoSuccess = (userInfo: DecodedIDTokenPayload | undefined) => {
    return {
        type: USER_INFO_SUCCESS,
        payload: userInfo
    }
}

export const fetchUserInfoFailure = (error: string) => {
    return {
        type: USER_INFO_FAILURE,
        payload: error
    }
}

export const fetchUserOrgInfoRequest = () => {
    return {
        type: USER_ORG_INFO_REQUEST
    }
}

export const fetchUserOrgInfoSuccess = (orgs: Organization[], status: number) => {
    return {
        type: USER_ORG_INFO_SUCCESS,
        payload: orgs,
        status: status
    }
}

export const fetchUserOrgInfoFailure = (error: string) => {
    return {
        type: USER_ORG_INFO_FAILURE,
        payload: error
    }
}

export const addEnterpriseUserRequest = () => {
    return {
        type: ADD_ENTERPRISE_USER_REQUEST
    }
}

export const addEnterpriseUserSuccess = (orgs: Organization[]) => {
    return {
        type: ADD_ENTERPRISE_USER_SUCCESS,
        payload: orgs
    }
}

export const addEnterpriseUserFailure = (error: string) => {
    return {
        type: ADD_ENTERPRISE_USER_FAILURE,
        payload: error
    }
}

export const changeUserOrganizationRequest = () => {
    return {
        type: CHANGE_ORG_REQUEST
    }
}

export const changeUserOrganizationSuccess = (selectedOrg: Organization) => {
    return {
        type: CHANGE_ORG_SUCCESS,
        payload: selectedOrg
    }
}

export const changeUserOrganizationFailure = (error: string) => {
    return {
        type: CHANGE_ORG_FAILURE,
        payload: error
    }
}

export const obtainApimTokenRequest = () => {
    return {
        type: OBTAIN_APIM_TOKEN_REQUEST
    }
}

export const obtainApimTokenSuccess = (user: User) => {
    return {
        type: OBTAIN_APIM_TOKEN_SUCCESS,
        payload: user
    }
}

export const obtainApimTokenFailure = (error: string) => {
    return {
        type: OBTAIN_APIM_TOKEN_FAILURE,
        payload: error
    }
}
